import {
  DimensionUnit,
  WeightUnit
} from 'generated/graphql';

import Big from 'big.js';



const __unitWeightConversionFactor: Record<WeightUnit, Record<WeightUnit, number>> = {
  grams: {
    grams: 1,
    kilograms: 1 / 1000,
    ounces: 35.274 / 1000,
    pounds: 2.20462 / 1000,
    unknown: 0
  },
  kilograms: {
    grams: 1000,
    kilograms: 1,
    pounds: 2.20462,
    ounces: 35.274,
    unknown: 0
  },
  pounds: {
    grams: (1 / 2.20462) * 1000,
    kilograms: 1 / 2.20462,
    pounds: 1,
    ounces: 16,
    unknown: 0
  },
  ounces: {
    grams: (1 / 35.274) * 1000,
    kilograms: 1 / 35.274,
    pounds: 1 / 16,
    ounces: 1,
    unknown: 0
  },
  unknown: {
    grams: 0,
    kilograms: 0,
    ounces: 0,
    pounds: 0,
    unknown: 0
  }
};

const __unitLengthConversionFactor: Record<DimensionUnit, Record<DimensionUnit, number>> = {
  feet: {
    feet: 1,
    inches: 12
  },
  inches: {
    feet: 1 / 12,
    inches: 1
  }
};



export function convertWeight(value: Big, from: WeightUnit, to: WeightUnit) {
  return value.mul(__unitWeightConversionFactor[from][to]);
}



export function convertLength(value: Big, from: DimensionUnit, to: DimensionUnit) {
  return value.mul(__unitLengthConversionFactor[from][to]);
}
